import { render, staticRenderFns } from "./SectionDialog.vue?vue&type=template&id=024abf2a"
import script from "./SectionDialog.vue?vue&type=script&lang=ts"
export * from "./SectionDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports